import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { IApplicationState } from '../../../../store';
import { Col3Col9 } from '../../../common';

const HeadlessSection = styled.div`
    padding-top 10px;
    padding-bottom: 60px;
    padding-left: 10px;
    padding-right: 10px;
`;

export const MenuSummary = () => {
	const { surveyAdminSummary } = useSelector((state: IApplicationState) => state.surveyAdmin);

	return (
		<HeadlessSection>
			{surveyAdminSummary?.summaryItems.map((item, index) => {
				return (
					<Col3Col9 key={index} label={item.displayName} labelSize={'md'} clearHeight={'0'}>
						{item.value}
					</Col3Col9>
				);
			})}
		</HeadlessSection>
	);
};
